import { Injectable } from '@angular/core';

@Injectable()
export class ConfigService {
  private sarappeRootUrl = 'https://portal.diagnosticsppe.office.com/';

  private saraprodRootUrl = 'https://incidents.diagnostics.office.com/';

  private sarasdfRootUrl = 'https://portal.diagnosticssdf.office.com/';

  private saraEnvironment = 'PROD';

  public odsUrl = '';

  constructor() {
    if (this.saraEnvironment === 'PPE') {
      this.odsUrl = this.sarappeRootUrl;
    } else if (this.saraEnvironment === 'PROD') {
      this.odsUrl = this.saraprodRootUrl;
    } else if (this.saraEnvironment === 'SDF') {
      this.odsUrl = this.sarasdfRootUrl;
    }
  }
}
